/*
 * Copyright (c) 2023 Helvia Technologies PC <contact@helvia.io>
 */
// components imports
import { Container } from "../Container";
import { Col, Row, Skeleton } from "antd";

export const DataLoadingSkeleton = () => {
  return (
    <Container>
      <Row className="my-5" justify="center" >
        <Col md={18} xs={24}>
          <Skeleton active />
        </Col>
      </Row>
    </Container>
  );
};
